import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  getLeftCheckedMailProcessingCenters,
  getRightCheckedMailProcessingCenters,
} from '../../../../common/user/redux/selectors/UserDataSelectors';
import { getAssetType } from '../../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { tableLoadData } from '../../../../common/tables/actions/ListTableActions';
import TableDefinitions from '../../../../common/TableDefinitions';
import ListTable from '../../../../common/tables/ListTable';
import { getColumns, getData, getIsLoading } from '../redux/selectors/ViewTransactionHistorySelectors';
import ViewTransactionHistorySelectionCriteriaContainer from './ViewTransactionHistorySelectionCriteriaContainer';
import DownloadTypes from '../../../../common/tables/excel/DownloadTypes';
import PreAdviceTransactionsHistoryContainer
  from '../../../impc-stock-levels/transactions/transactions-history/pre-advice/containers/PreAdviceTransactionsHistoryContainer';
import RepatriationsTransactionsHistoryContainer
  from '../../../impc-stock-levels/transactions/transactions-history/repatriations/containers/RepatriationsTransactionsHistoryContainer';
import PredesTransactionsHistoryContainer
  from '../../../impc-stock-levels/transactions/transactions-history/predes/containers/PredesTransactionsHistoryContainer';
import { getGlobalEndDate } from '../../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';
import { setGlobalEndDateSelectionActionCreator, setGlobalStartDateSelectionActionCreator } from '../../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';

const leftTree = {
  title: 'Outbound Operators or IMPCs',
  roleFilter: false,
};
const rightTree = {
  title: 'Inbound Operators or IMPCs',
  roleFilter: true,
};

class ViewTransactionHistoryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedStartDate: moment(this.props.globalEndDate).subtract(1, 'month').format('YYYY-MM-DD'),
      selectedEndDate: moment(this.props.globalEndDate).format('YYYY-MM-DD'),
    };
  }

  onStartDateChange = (newDate) => {
    if (moment(this.state.selectedEndDate).diff(moment(new Date(newDate)), 'days') <= 30) {
      this.setState({
        selectedStartDate: newDate,
      });
    } else {
      this.setState({
        selectedStartDate: newDate,
        selectedEndDate: moment(new Date(newDate)).add(1, 'month').format('YYYY-MM-DD'),
      });
      this.props.setGlobalEndDateSelectionActionCreator(moment(new Date(newDate)).add(1, 'month'));
    }
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onEndDateChange = (newDate) => {
    this.setState({
      selectedEndDate: newDate,
    });
    this.props.setGlobalEndDateSelectionActionCreator(newDate);
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: 'TRANSACTION_HISTORY' },
      this.props.appContext.appContext,
      {
        endDate: this.state.selectedEndDate,
        fromImpcs: this.props.leftCheckedMailProcessingCenters,
        startDate: this.state.selectedStartDate,
        toImpcs: this.props.rightCheckedMailProcessingCenters,
      },
    );
  };

  render() {
    const {
      isLoading,
      data,
      columns,
    } = this.props;
    const { showResult, selectedStartDate, selectedEndDate } = this.state;

    return (
      <div>
        <ViewTransactionHistorySelectionCriteriaContainer
          open={data.length === 0}
          title="View Transactions History"
          onApply={this.onCriteriaApply}
          selectedStartDate={selectedStartDate}
          onStartDateChange={this.onStartDateChange}
          selectedEndDate={selectedEndDate}
          onEndDateChange={this.onEndDateChange}
          leftTree={leftTree}
          rightTree={rightTree}
          switchEnabled
        />
        <div className="general-content-container">
          {(showResult || data.length > 0) && (
            <div className="full-width">
              <div className="list-table-container" style={{ paddingBottom: '20px', minHeight: '740px' }}>
                <ListTable
                  listId={TableDefinitions.TRANSACTION_HISTORY.id}
                  loading={isLoading}
                  columns={columns}
                  data={this.props.data}
                  keyField="id"
                  selectCheckbox
                  pagination
                  downloadType={DownloadTypes.EXCEL}
                  getSubComponentProps={(row) => (
                    <div style={{ padding: '20px' }}>
                      {row.original.transactionType === 'GFP' && (
                        <PredesTransactionsHistoryContainer
                          row={row}
                          refreshTransactions={this.onCriteriaApply}
                        />
                      )}
                      {row.original.transactionType === 'MPA' && (
                        <PreAdviceTransactionsHistoryContainer
                          row={row}
                          refreshTransactions={this.onCriteriaApply}
                        />
                      )}
                      {(row.original.transactionType === 'IRO' || row.original.transactionType === 'CRO') && (
                        <RepatriationsTransactionsHistoryContainer
                          row={row}
                          refreshTransactions={this.onCriteriaApply}
                        />
                      )}
                    </div>
                  )}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

ViewTransactionHistoryContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  leftCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  rightCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  isLoading: PropTypes.bool,
  globalEndDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
  setGlobalEndDateSelectionActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
    appContext: getAssetType(state),
    isLoading: getIsLoading(state),
    globalEndDate: getGlobalEndDate(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  setGlobalStartDateSelectionActionCreator,
  setGlobalEndDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewTransactionHistoryContainer);
